const TRANSLATE_DATA = {
	es: {
		months: [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
      "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ],
    weekdays: [
      "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
    ]
	}
};

export default TRANSLATE_DATA;



// WEBPACK FOOTER //
// ./app/constants/LanguageConfig.js